import { render, staticRenderFns } from "./create.vue?vue&type=template&id=2ab64f22&scoped=true"
import script from "./create.vue?vue&type=script&lang=js"
export * from "./create.vue?vue&type=script&lang=js"
import style0 from "./create.vue?vue&type=style&index=0&id=2ab64f22&lang=scss&scoped=true"
import style1 from "./create.vue?vue&type=style&index=1&id=2ab64f22&scoped=true&lang=css"
import style2 from "./create.vue?vue&type=style&index=2&id=2ab64f22&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab64f22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ab64f22')) {
      api.createRecord('2ab64f22', component.options)
    } else {
      api.reload('2ab64f22', component.options)
    }
    module.hot.accept("./create.vue?vue&type=template&id=2ab64f22&scoped=true", function () {
      api.rerender('2ab64f22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods/create.vue"
export default component.exports